import Avatar from './Avatar';
export { default as AvatarSpace } from './AvatarSpace';
export default Avatar;
